module.exports = __webpack_public_path__ + "img/tp-101-4.93dd7673.png";